import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=493cf3b0&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=js&"
export * from "./chat.vue?vue&type=script&lang=js&"
import style0 from "./chat.vue?vue&type=style&index=0&id=493cf3b0&prod&lang=less&scoped=true&"
import style1 from "./chat.vue?vue&type=style&index=1&id=493cf3b0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493cf3b0",
  null
  
)

export default component.exports